/**
 * Where an applicant's session is remembered. `sessionStorage`, so a shared or
 * public computer holds nothing once the tab is closed. Nothing else about an
 * applicant is stored in the browser: answers live on the server.
 */
export const APPLICANT_SESSION_KEY = 'remittance-intake.applicant-session';
